import {Locale} from '../../../types/locale';
import {isBankDataEntered} from '../utils/isBankDataEntered';
import useCodPaymentInformation from './useCodPaymentInformation';

export default function useBankDataState(
  locale: Locale,
  isOnBankDataPage: boolean,
) {
  const {
    data: {codPaymentInformation, loadingCache, error},
    fetchCodPaymentInformation,
    updateOrCreateBankInformation,
  } = useCodPaymentInformation(locale, isOnBankDataPage);

  const userHasBankData = isBankDataEntered(codPaymentInformation);

  return {
    codPaymentInformation,
    loadingCache,
    updateOrCreateBankInformation,
    userHasBankData,
    fetchCodPaymentInformation,
    error,
  };
}
